import { makeAutoObservable } from 'mobx';
import { Point } from '@/models/Point';
import type { ICircuitModel, IPoint, IStructureCircuitModel } from '@/interfaces/models';

export class StructureCircuitModel implements IStructureCircuitModel {
  originLocation: IPoint = new Point(0, 0);

  constructor(public circuitModel: ICircuitModel) {
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
